module.exports = __webpack_public_path__ + "static/img/product03.4763ad8d.png";